﻿(function () {
  var roots = document.querySelectorAll('.outlet-lojas');
  if (!roots.length) return;

  roots.forEach(function (root) {
    root.querySelectorAll('.carrossel-wrap, .show-wrap').forEach(function (wrap) {
      var track = wrap.querySelector('.carrossel, .show-carrossel');
      if (!track || !track.children.length) return;

      var slides = track.children;
      var prev = wrap.querySelector('.seta.prev');
      var next = wrap.querySelector('.seta.next');
      var isDragging = false;
      var startX = 0;
      var startScroll = 0;

      function step() {
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 16;
        return slides[0].getBoundingClientRect().width + gap;
      }

      function move(delta) {
        var target = track.scrollLeft + delta;
        if ('scrollBehavior' in document.documentElement.style) {
          track.scrollTo({ left: target, behavior: 'smooth' });
        } else {
          track.scrollLeft = target;
        }
      }

      if (prev) {
        prev.addEventListener('click', function (event) {
          event.preventDefault();
          move(-step());
        });
      }

      if (next) {
        next.addEventListener('click', function (event) {
          event.preventDefault();
          move(step());
        });
      }

      track.addEventListener('mousedown', function (event) {
        isDragging = true;
        startX = event.pageX;
        startScroll = track.scrollLeft;
        track.classList.add('arrastando');
      });

      window.addEventListener('mousemove', function (event) {
        if (!isDragging) return;
        var delta = event.pageX - startX;
        track.scrollLeft = startScroll - delta;
      });

      window.addEventListener('mouseup', function () {
        if (!isDragging) return;
        isDragging = false;
        track.classList.remove('arrastando');
      });
    });

    root.querySelectorAll('.show-wrap').forEach(function (wrap) {
      var track = wrap.querySelector('.show-carrossel');
      var dots = wrap.parentElement ? wrap.parentElement.querySelector('.pontos') : null;
      if (!track || !dots) return;

      var slides = Array.prototype.slice.call(track.children);
      dots.innerHTML = '';

      slides.forEach(function (slide, index) {
        var button = document.createElement('button');
        button.className = 'ponto' + (index === 0 ? ' ativo' : '');
        button.setAttribute('aria-label', 'Ir para o slide ' + (index + 1));
        button.addEventListener('click', function () {
          slide.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        });
        dots.appendChild(button);
      });

      track.addEventListener(
        'scroll',
        function () {
          var center = track.scrollLeft + track.clientWidth / 2;
          var activeIndex = 0;
          var minDistance = Infinity;

          slides.forEach(function (slide, index) {
            var slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
            var distance = Math.abs(slideCenter - center);
            if (distance < minDistance) {
              minDistance = distance;
              activeIndex = index;
            }
          });

          dots.querySelectorAll('.ponto').forEach(function (dot, index) {
            dot.classList.toggle('ativo', index === activeIndex);
          });
        },
        { passive: true }
      );
    });
  });
})();